import * as yup from 'yup';
import { TFunction } from 'i18next';
import { languageMap } from '../../../app/data/models/common/localizedLanguage';
import { LanguageCode } from '../../../app/data/models/common/localizedLanguage';
import { KitchenFormData } from '../../../app/data/models/kitchens/kitchenFormData';

export const kitchenValidationSchema = (
  t: TFunction,
  languageCodes: LanguageCode[]
): yup.ObjectSchema<KitchenFormData> => {
  const namesShape = languageCodes.reduce(
    (acc, code) => ({
      ...acc,
      [code]: yup
        .string()
        .required(
          t('kitchen.validation.name-required', { field: languageMap[code] })
        ),
    }),
    {}
  );

  return yup.object({
    id: yup.string().optional(),
    names: yup.object().shape(namesShape).required(),
  }) as yup.ObjectSchema<KitchenFormData>;
};
